import React, { Component } from 'react';
import classNames from 'classnames';
import './styles.css';

/**
 * Description
 *
 * @typedef {Object} Props
 * @prop {String} [className]
 * @prop {String} [href]
 * @prop {Boolean} [download]
 * @prop {String} [buttonLabel]
 *
 * @augments {Component<Props>}
 */
export default class DownloadButton extends Component {
	genClassName = (props) =>
		classNames('DownloadButton', { [props.className]: true });

	render () {
		const { href, download, buttonLabel } = this.props;
		const arrowDown = require(`../../../assets/svg/icon-arrow-down.svg`);

		return (
			<a
				className={this.genClassName(this.props)}
				href={href}
				rel='noopener noreferrer'
				download={download}
				target='_blank'
			>
				<img src={arrowDown} alt='Arrow Down' />
				<span>{buttonLabel}</span>
			</a>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/atoms/DownloadButton/DownloadButton.js